import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useDataFetchIndicator } from '..';
import vopayApi from '@/services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.TransactionsHistoryResponse, (requestParams: vp.TransactionsHistoryRequest) => void, () => void];

const defaults = {
  ErrorMessage: '',
  Success: false,
  NumberOfRecords: 0,
  PDFFile: '',
  CSVFile: '',
  Transactions: [],
  PaginationMetaData: {
    TotalRecords: 0,
    Offset: 0,
    Limit: 20,
  },
};
function useFetchTransactionsFile({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<vp.TransactionsHistoryRequest>();
  const [response, setResponse] = useState<vp.TransactionsHistoryResponse>(defaults);
  const [shouldSendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    const sendRequest = async (requestParams: vp.TransactionsHistoryRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.fetchTransactionsHistory(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.TransactionsHistoryRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setSendRequest(false);
      setParams(undefined);
      setResponse(defaults);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchTransactionsFile);
